export default "__VITE_ASSET__CPEHAqsA__"